module.exports = class DefaultSchemaErrorMessagesFactory {
  constructor(schema, schemaErrorMessages) {
    this._schema = schema;
    this._schemaErrorMessages = schemaErrorMessages;
  }

  build() {
    return {
      bankCode: {
        errorMessage: this._schemaErrorMessages.BANK_CODE_FORMAT_ERROR.message,
        errorCode: this._schemaErrorMessages.BANK_CODE_FORMAT_ERROR.code,
        errorData: this._schemaErrorMessages.BANK_CODE_FORMAT_ERROR.data
      },
      bankISPB: {
        errorMessage: this._schemaErrorMessages.BANK_ISPB_FORMAT_ERROR.message,
        errorCode: this._schemaErrorMessages.BANK_ISPB_FORMAT_ERROR.code,
        errorData: this._schemaErrorMessages.BANK_ISPB_FORMAT_ERROR.data
      },
      agency: {
        errorMessage: this._schemaErrorMessages.AGENCY_MAX_LENGTH.message,
        errorCode: this._schemaErrorMessages.AGENCY_MAX_LENGTH.code,
        errorData: this._schemaErrorMessages.AGENCY_MAX_LENGTH.data,
        digit: {
          errorMessage: this._schemaErrorMessages.AGENCY_DIGIT_NUMERIC.message,
          errorCode: this._schemaErrorMessages.AGENCY_DIGIT_NUMERIC.code,
          errorData: this._schemaErrorMessages.AGENCY_DIGIT_NUMERIC.data
        }
      },
      account: {
        errorMessage: this._schemaErrorMessages.ACCOUNT_MAX_LENGTH.message,
        errorCode: this._schemaErrorMessages.ACCOUNT_MAX_LENGTH.code,
        errorData: this._schemaErrorMessages.ACCOUNT_MAX_LENGTH.data,
        digit: {
          errorMessage: this._schemaErrorMessages.ACCOUNT_DIGIT_NUMERIC.message,
          errorCode: this._schemaErrorMessages.ACCOUNT_DIGIT_NUMERIC.code,
          errorData: this._schemaErrorMessages.ACCOUNT_DIGIT_NUMERIC.data
        }
      },
      accountType: {
        errorMessage: this._schemaErrorMessages.ACCOUNT_TYPE.message,
        errorCode: this._schemaErrorMessages.ACCOUNT_TYPE.code,
        errorData: this._schemaErrorMessages.ACCOUNT_TYPE.data
      }
    };
  }
};
